var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C14.5908 0 6.15234 8.43838 6.15234 18.8477C6.15234 22.3288 6.83372 25.9242 8.78905 28.5156L25 50L41.2109 28.5156C42.987 26.1619 43.8476 22.0008 43.8476 18.8477C43.8477 8.43838 35.4093 0 25 0ZM25 10.9161C29.3798 10.9161 32.9315 14.4678 32.9315 18.8476C32.9315 23.2275 29.3798 26.7792 25 26.7792C20.6202 26.7792 17.0685 23.2275 17.0685 18.8477C17.0685 14.4678 20.6202 10.9161 25 10.9161Z",
    fill: "#6562AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.70b147035e4f0c2d4212133786756358.svg";
export { ForwardRef as ReactComponent };